import React, { Component } from 'react'
import { Col, Row, Label, Button } from 'reactstrap'
import { observer } from 'mobx-react';
import { formatNullableValue } from '../../../../utils/formatar';

@observer
export default class CardConsulta extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    renderFields(col) {
        if(col.typeButton) {
            if(this.props.data.Status !== "C"){
                return (
                    <div className="info bg-cinza">
                        <div className="titulo">{col.text}</div>
                        <div className="valor">
                            <Button className="px-2 btn-com-bordas-cinza" onClick={() => col.buttonOnclick(this.props.data[col.dataField], this.props.data, col.inputClick, true)}>
                                {col.typeButton}
                            </Button>
                        </div>
                    </div>
                )
            } else {
                return (<div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        ---
                    </div>
                </div>)
            }
        } else if(col.formatter) {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue( col.formatter(this.props.data[col.dataField], this.props.data))}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue(this.props.data[col.dataField], this.props.data)}
                    </div>
                </div>
            );
        }
    }


    render() {
        return (
            <Col xs={12} md={6} lg={4} className="px-0">
                <div className="card-navio">
                    <Row xs={12} className="px-0">
                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                            </div>
                        </Col>

                        {
                            this.props.colunas.map((col, index) => 
                            (col.dataField !== this.props.titulo) &&
                            <Col xs={col.dataField === "StatusDesc" ? 12 : 6} className="px-0" key={index}>
                                {this.renderFields(col)}
                            </Col>
                            )
                        }

                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/components/CardConsulta.js